import { Avatar, Box, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { AppAnimatedText } from 'src/component/common/analog/molecule/AppAnimatedText'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { ColorTokens, Palette } from 'src/feature/theme/model/Palette'
import { useUserStore } from 'src/feature/user/store/user.store'

const getUserInitials = (name?: string) => {
  if (!name) {
    return ''
  }

  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? '')
    .join('')

  return initials || name.slice(0, 2).toUpperCase()
}

const formatMemberSince = (createdAt?: Date) => {
  if (!createdAt) {
    return ''
  }

  return new Date(createdAt).toLocaleDateString()
}

export const GetStarted = observer(() => {
  const userStore = useUserStore()
  const { translation } = useLocalizationStore()

  const translations = translation.pages.myGrowth
  const profileCardTranslation = translation.pages.profileInfo.profileCard
  const { userData, avatar, fullName } = userStore
  const userName = fullName || userData?.firstName || userData?.email || 'User'
  const memberSince = formatMemberSince(userData?.createdAt)
  const hasEmail = Boolean(userData?.email)

  return (
    <Box sx={styles.root}>
      <Avatar src={avatar} sx={styles.profileAvatar}>{getUserInitials(userName)}</Avatar>
      <AppBox sx={styles.infoColumn}>
        <AppAnimatedText
          text={`${translations.welcomeMsg()}, ${userName}!`}
          delay={50}
          sx={styles.welcomeText}
        />
        {hasEmail && (
          <Typography sx={styles.metaText}>{userData?.email}</Typography>
        )}
        {memberSince && (
          <Typography sx={styles.metaText}>
            {profileCardTranslation.memberSince()} {memberSince}
          </Typography>
        )}
      </AppBox>
    </Box>
  )
})

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 10,
    borderRadius: '12px',
    padding: '10px 15px',
    background: `linear-gradient(180deg, ${Palette.DEEP_SEA_BLUE} 0%, ${Palette.CORAL_REEF_GREEN} 100%)`,
  },
  welcomeText: {
    fontSize: 18,
    color: Palette.WHITE,
  },
  infoColumn: {
    flexDirection: 'column',
    gap: 1,
  },
  metaText: {
    color: ColorTokens.neutral300,
    fontSize: 12,
  },
  profileAvatar: {
    width: 60,
    height: 60,
    flexShrink: 0,
  },
}